import { Routes } from '@angular/router';
import { safeLoadComponent, safeLoadChildren } from './services/route-error-handler';

export const routes: Routes = [
  {
    path: 'admin-invite',
    loadComponent: safeLoadComponent(
      () => import('./components/pages/admin-invite-acceptance/admin-invite-acceptance.component'),
      'AdminInviteAcceptanceComponent',
      '/'
    ),
  },
  {
    path: 'forbidden',
    loadComponent: safeLoadComponent(
      () => import('./components/forbidden/forbidden.component'),
      'ForbiddenComponent',
      '/'
    ),
  },
  {
    path: 'admin',
    loadChildren: safeLoadChildren(
      () => import('./admin/admin.routes'),
      'adminRoutes',
      '/'
    ),
  },
  {
    path: '',
    loadComponent: safeLoadComponent(
      () => import('./public/public.component'),
      'PublicComponent',
      '/'
    ),
    loadChildren: safeLoadChildren(
      () => import('./public/public.routes'),
      'publicRoutes',
      '/'
    ),
  },
  // {
  //   path: '**',
  //   loadComponent: () =>
  //     import('./components/not-found/not-found.component').then(
  //       (m) => m.NotFoundComponent
  //     ),
  // },
];
